import { Outlet, useLocation, Navigate } from "react-router";
import { useAuth } from "./AuthContext";

const SubmissionDashboardProtectedRoute = () => {
  const { user, loading, profile } = useAuth();
  const location = useLocation();

  // If still loading user or profile, show a loading indicator
  if (loading || (!profile && user)) {
    return (
      <div
        style={{
          height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span className="page-loader"></span>
      </div>
    ); // Or replace with a better UI spinner
  }

  // If user is not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If profile is still null after loading, prevent access
  if (!profile) {
    return <Navigate to="/" replace />;
  }

  // If the user does not have the required role, redirect home
  if (!profile?.roles?.includes("reviewer")) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default SubmissionDashboardProtectedRoute;
